// material-ui
import Drawer from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';
// project import
import { drawerWidth } from 'config';
import { CustomTheme } from 'themes';

const openedMixin = (theme: CustomTheme): React.CSSProperties => ({
    width: drawerWidth,
    borderRight: `1px solid ${theme.palette.divider}`,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
    }),
    overflowX: 'hidden',
    boxShadow: 'none'
});

const closedMixin = (theme: CustomTheme): React.CSSProperties => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    width: 0,
    borderRight: 'none',
    boxShadow: theme.customShadows.z1
});

// ==============================|| DRAWER - MINI STYLED ||============================== //

const MiniDrawerStyled = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
        ...openedMixin(theme as CustomTheme),
        '& .MuiDrawer-paper': openedMixin(theme as CustomTheme)
    }),
    ...(!open && {
        ...closedMixin(theme as CustomTheme),
        '& .MuiDrawer-paper': closedMixin(theme as CustomTheme)
    })
}));

export default MiniDrawerStyled;
